"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingGetPenaltyBalanceButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const exchange_1 = require("@framework/exchange");
const styled_1 = require("@framework/styled");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const getPenalty_json_1 = __importDefault(require("@framework/abis/json/Staking/getPenalty.json"));
const StakingGetPenaltyBalanceButton = (props) => {
    const { balance, className, disabled, variant } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { execute: metaGetPenalty } = (0, react_hooks_eth_1.useMetamaskValue)(async (balance) => {
        return writeContractAsync({
            address: balance.account,
            abi: getPenalty_json_1.default,
            functionName: "getPenalty",
            args: [balance.token.template.contract.address, balance.token.tokenId],
        });
    }, { success: false });
    const handleClick = async () => {
        const amount = (await metaGetPenalty(balance));
        if (amount) {
            alert((0, exchange_1.formatEther)(amount.toString(), balance.token?.template?.contract?.decimals, balance.token?.template?.contract?.symbol));
        }
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleClick, icon: icons_material_1.Policy, message: "form.tips.penalty", className: className, dataTestId: "StakingPenaltyBalanceButton", disabled: disabled, variant: variant }));
};
exports.StakingGetPenaltyBalanceButton = StakingGetPenaltyBalanceButton;
//# sourceMappingURL=index.js.map